
import Vue from 'vue';
import AdFormBanner from './AdFormBanner.vue';
import { AdFormOptions } from '@ads/types/AdForm';
import { gridConfig } from '@core/config/grid.config';

interface Props {
  settings: AdFormOptions;
}

interface Data {
  hasSiteHeader: boolean;
  isSticky: boolean;
  observer: MutationObserver | null;
  siteHeaderCheckDone: boolean;
}

interface Methods {
  handleSticky: () => void;
}

interface Computed {
  isMobileOrTablet: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    AdFormBanner,
  },
  props: {
    settings: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {
      hasSiteHeader: false,
      isSticky: false,
      observer: null,
      siteHeaderCheckDone: false,
    };
  },
  computed: {
    isMobileOrTablet() {
      return (typeof window !== 'undefined' && window.innerWidth <= 991) || false;
    },
  },
  watch: {
    siteHeaderCheckDone(value) {
      if (value && !this.hasSiteHeader) {
        const resizeObserver = new ResizeObserver((entries) => {
          const bodyPaddingTop = (this.isMobileOrTablet ? 50 : 115) + entries[0].contentRect.height;
          const body = document.querySelector('body') as HTMLElement;
          body.style.paddingTop = bodyPaddingTop + 'px';
        });
        resizeObserver.observe(document.querySelector('#plius-promotion-line') as Element);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      // Disable sticky in Internet Explorer
      if (this.$ua.browser() !== 'Internet Explorer') {
        this.handleSticky();
        window.addEventListener('scroll', this.handleSticky);
        window.addEventListener('resize', this.handleSticky);
      }

      setTimeout(() => {
        const siteHeader = document.querySelector('#delfi-adx-siteheader');
        this.hasSiteHeader = !!siteHeader?.querySelector('iframe');
        this.siteHeaderCheckDone = true;
      }, 1500);
    });
  },
  methods: {
    handleSticky() {
      const element: Element | null = document.querySelector('#plius-promotion-line');
      const elementHeight: number = element?.clientHeight || 50;

      if (window.innerWidth > gridConfig.breakpoints.lg) {
        const scroll: number = window.pageYOffset;
        this.isSticky = scroll >= elementHeight;
      } else {
        this.isSticky = true;
      }
    },
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
});
